import { Col, Label } from "reactstrap";
import { InputField } from "../../../../Component/Forms/FormsControl/CustomInput/CustomInput";
import CustomRadioButton from "../../../../Component/Forms/FormsControl/CustomRadioButton/CustomRadioButton";
import ErrorComponent from "../../../../Component/Forms/FormsControl/ErrorComponent";
import CustomCheckbox from "../../../../Component/Forms/FormsControl/CustomCheckbox/CustomCheckbox";
import { CustomSelectInput } from "../../../../Component/Forms/FormsControl/CustomSelectInput/CustomSelectInput";
import { IUserDetailsCommon } from "../../../../Types/Common";
import { IAdditionalManagerUserList } from "../../../../Types/DailyReport";
import { ICenters } from "../../../../Types/Center";
import FormikMultiSelectSearch from "../../../../Component/Forms/FormsControl/FormikMultiSelectSearch";
import { IDesignation } from "../../../designation/types";
import NewCustomFormikDatePicker from "../../../../Component/Forms/FormsControl/NewFormikDatePicker";
import CkEditorField from "../../../dailyDairyReport/components/Editor/CkEditorField";

const QuestionField = ({
  index,
  question,
  errors,
  touched,
  userListData,
  departmentList,
  centersList,
  designationList,
}: {
  index: number;
  question: any;
  errors: any;
  touched: any;
  userListData?: IAdditionalManagerUserList[];
  departmentList?: IUserDetailsCommon[];
  centersList?: ICenters[];
  designationList?: IDesignation[];
}) => {
  const {
    is_required: isRequired,
    options,
    question_label: questionLabel,
    question_type: questionType,
    question_id: questionId,
  } = question;
  const name = `question_${questionId}`;

  // options based on label
  let dynamicOptions: { value: any; label: string }[] = [];

  if (questionLabel === "Team Lead Name:") {
    dynamicOptions =
      userListData?.map((u: IAdditionalManagerUserList) => ({
        value: u.name,
        label: u.name,
      })) || [];
  } else if (questionLabel === "Department:") {
    dynamicOptions =
      departmentList?.map((d: IUserDetailsCommon) => ({
        value: d.name,
        label: d.name,
      })) || [];
  } else if (questionLabel === "Designation:") {
    dynamicOptions =
      designationList?.map((d: IDesignation) => ({
        value: d.name,
        label: d.name,
      })) || [];
  } else if (questionLabel === "Centers:") {
    dynamicOptions =
      centersList?.map((c: ICenters) => ({ value: c.name, label: c.name })) ||
      [];
  } else {
    dynamicOptions =
      options?.map((o: string) => ({ value: o, label: o })) || [];
  }

  // Dynamically set column size
  const colClass =
    questionType === 4 || questionType === 5 || questionType === 6
      ? "col-sm-12 col-md-7 mb-3"
      : "col-12 mb-3";

  return (
    <Col className={colClass} key={questionId}>
      <Label
        className="form-label fw-semibold mb-3 mt-3"
        style={{ fontSize: "1rem" }}
      >
        {index}: {questionLabel}
        {isRequired ? <span className="text-danger"> *</span> : null}
      </Label>

      {questionType === 1 && (
        <InputField
          as="textarea"
          name={name}
          errors={errors}
          touched={touched}
          md="12"
          rows="2"
          placeholder="Type your response"
        />
      )}

      {questionType === 2 &&
        options?.map((option: string, i: number) => (
          <CustomRadioButton
            key={i}
            name={name}
            as="radio"
            value={option}
            fieldClassName=""
            radioBtnTitle={option}
            errorComponent="div"
            formGroupClassName={i + 1 !== options.length ? "mb-0" : " mb-0"}
          />
        ))}
      {errors?.[name] && questionType === 2 && <ErrorComponent name={name} />}

      {questionType === 3 &&
        options?.map((option: string, i: number) => (
          <CustomCheckbox
            key={i}
            name={name}
            value={option}
            checkboxBtnTitle={option}
            fieldClassName="checkbox_animated ms-1 mb-0"
            isLast={i + 1 === options.length}
          />
        ))}

      {questionType === 4 && (
        <div className="mb-0">
          <CustomSelectInput
            label=""
            labelClassName="d-none"
            name={name}
            type="select"
            fieldClassName={`form-select mb-0 w-100 ${
              errors?.[name] && touched?.[name] ? "is-invalid" : ""
            }`}
          >
            {dynamicOptions.map((opt, i) => (
              <option key={i} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </CustomSelectInput>
        </div>
      )}

      {questionType === 5 && (
        <FormikMultiSelectSearch
          label=""
          labelClassName="d-none"
          name={name}
          options={dynamicOptions}
          labelKey="label"
          placeholder="Select options..."
        />
      )}

      {/* questionType === 6 to use DatePicker */}
      {questionType === 6 && (
        <NewCustomFormikDatePicker
          label=""
          name={name}
          labelClassName="d-none"
          placeholder="Select Date"
        />
      )}

      {/* questionType === 7 to use CkEditor */}
      {questionType === 7 && (
        <div
          style={{
            maxHeight: "250px",
            overflowY: "auto",
          }}
        >
          <CkEditorField
            name={name}
          />
        </div>
      )}

    </Col>
  );
};

export default QuestionField;
